var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"py-0 text-left font-weight-light",attrs:{"cols":"8"}},[_vm._v(_vm._s(_vm.title))]),_c('v-col',{staticClass:"py-0 text-right font-weight-normal",attrs:{"cols":"4"}},[_vm._v(_vm._s(_vm.montant))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }